import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ReportDom from "../../../components/common/ReportDom";
import SalesVoucherBody from "./SalesVoucherBody";
import SalesVoucherBodyDesignA from "./SalesVoucherBodyDesignA";
import { fetchSingleInstitutionDetails } from "../../../store/commonThunks/lookups";

export default function PrintSalesVoucher({id : sale_id}) {
  const [ready, setReady] = useState(false);
  const dispatch = useDispatch();
  const { institutionData } = useSelector((state) => state.lookups);
  const isDesignA = institutionData?.print_template === "design_a";

  useEffect(() => {
    // See PrintSalesVoucher.jsx's standalone-route version of this same
    // fix -- institutionData.print_template can't be assumed to already be
    // loaded just because this component mounted.
    dispatch(fetchSingleInstitutionDetails()).finally(() => setReady(true));
  }, [dispatch]);

  if (!ready) return null;

  return (
    <div style={{ background: "#fff", padding: 0 }}>
      {isDesignA ? (
        <ReportDom mode="no-title" renderTable={() => <SalesVoucherBodyDesignA sale_id={sale_id} />} />
      ) : (
        <ReportDom
          renderTable={() => (
            <SalesVoucherBody
              sale_id={sale_id}
              printMode
              showStamp
              showSignature
            />
          )}
        />
      )}
    </div>
  );
}
